import {
  EntityList,
  EntityListProps,
  renderInvertedYesNoIcon,
} from 'components/EntityList'
import { ProvingGround } from 'model'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type ProvingGroundListProps = EntityListProps<Partial<ProvingGround>>

export const ProvingGroundList: React.FunctionComponent<
  ProvingGroundListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={[
        fieldColumn('inactive', {
          minWidth: 40,
          maxWidth: 40,
          onRender: renderInvertedYesNoIcon,
          ungroupable: true,
          name: t('field.active.label'),
        }),
        fieldColumn('abbr', {
          minWidth: 75,
          maxWidth: 100,
          ungroupable: true,
        }),
        fieldColumn('title', {
          minWidth: 150,
          maxWidth: 200,
          isSorted: true,
          ungroupable: true,
        }),
        fieldColumn('countryCode', {
          minWidth: 75,
          maxWidth: 75,
          ungroupable: true,
        }),
        fieldColumn('specialNote', {
          minWidth: 150,
          maxWidth: 250,
          ungroupable: true,
        }),
      ]}
      {...props}
    />
  )
}
